import gql from 'graphql-tag'
import { PageInfoFragment, AssetTagSpaceDetailsFragment } from '@api/fragments'
import { IPageInfo, IAssetDetailsSpace } from '@api/types'
import client from '@stores/apollo'

interface AssetSpacesVars {
  id: string
  first: number
  after?: string
  query?: string
}

const spacesQuery = gql`
  query assetSpaces($id: ID!, $after: String, $where: SpaceWhereInput, $first: Int) {
    node(id: $id) {
      ... on Tag {
        spaces(after: $after, where: $where, orderBy: name_ASC, first: $first) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...AssetTagSpaceDetailsFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${AssetTagSpaceDetailsFragment}
`

export default function list({ id, first = 5, query = '', after = '' }: AssetSpacesVars): Promise<{
  counters: {
    total: number
  }
  pageInfo: IPageInfo
  spaces: IAssetDetailsSpace[]
}> {
  return client.gql
    .query({
      query: spacesQuery,
      variables: {
        id,
        first,
        after,
        where: {
          OR: [{ externalId_contains: query }, { name_contains: query }],
        },
      },
    })
    .then(
      ({
        data: {
          node: {
            spaces: { counters, edges, pageInfo },
          },
        },
      }: {
        data: {
          node: {
            spaces: {
              pageInfo: IPageInfo
              counters: { total: number }
              edges: { node: IAssetDetailsSpace }[]
            }
          }
        }
      }) => ({
        counters,
        pageInfo,
        spaces: edges.map(({ node }) => node),
      })
    )
}
